import { useQuery } from "@tanstack/react-query";
import { fetchAccountCluster, type AccountClusterResponse } from "../api.js";

export function useAccountCluster(
  aid: number | null
): ReturnType<typeof useQuery<AccountClusterResponse>> {
  return useQuery<AccountClusterResponse>({
    queryKey: ["accountCluster", aid],
    queryFn: () => fetchAccountCluster(aid as number),
    enabled: aid !== null,
    staleTime: 30_000,
  });
}
